/**
 * Opciones para tipo de negocio y subtipos en el OnBoarding
 * Centralizadas para evitar duplicación de código
 */

// Tipos de negocio principales
export const businessTypeOptions = [
  { value: 'restaurante', label: 'Restaurante' },
  { value: 'dark_kitchen', label: 'Dark kitchen' },
  { value: 'cafeteria', label: 'Cafetería' },
  { value: 'bar', label: 'Bar' },
  { value: 'fonda', label: 'Fonda / Cocina económica' },
  { value: 'food_truck', label: 'Food truck' },
  { value: 'comida_rapida', label: 'Comida Rápida' },
  { value: 'club_nocturno', label: 'Club nocturno' },
  { value: 'taqueria', label: 'Taquería' },
  { value: 'otro', label: 'Otro comercio de comida' },
  { value: 'no_gastronomico', label: 'No gastronómico' },
];

// Subtipos por tipo de negocio
export const businessSubTypes = {
  // Restaurante / Dark Kitchen - Estilos de Cocina
  restaurante: [
    { value: 'mexicana', label: 'Mexicana: Cocina tradicional, antojitos, gourmet mexicano.' },
    { value: 'italiana', label: 'Italiana: Pastas, pizzas, cocina mediterránea.' },
    { value: 'asiatica', label: 'Asiática: China, japonesa (sushi), tailandesa, vietnamita.' },
    { value: 'americana', label: 'Americana: Hamburguesas, BBQ, alitas, comida cajún.' },
    { value: 'cortes_carne', label: 'Cortes de Carne / Grill: Steaks, parrilla, asados.' },
    { value: 'pescados_mariscos', label: 'Pescados y Mariscos: Cevichería, cocina del mar.' },
    { value: 'internacional', label: 'Internacional / Fusión: Cocina de autor, mezcla de estilos.' },
    { value: 'saludable', label: 'Saludable: Vegetariana, vegana, ensaladas, bowls.' },
  ],

  dark_kitchen: [
    { value: 'mexicana', label: 'Mexicana: Cocina tradicional, antojitos, gourmet mexicano.' },
    { value: 'italiana', label: 'Italiana: Pastas, pizzas, cocina mediterránea.' },
    { value: 'asiatica', label: 'Asiática: China, japonesa (sushi), tailandesa, vietnamita.' },
    { value: 'americana', label: 'Americana: Hamburguesas, BBQ, alitas, comida cajún.' },
    { value: 'cortes_carne', label: 'Cortes de Carne / Grill: Steaks, parrilla, asados.' },
    { value: 'pescados_mariscos', label: 'Pescados y Mariscos: Cevichería, cocina del mar.' },
    { value: 'internacional', label: 'Internacional / Fusión: Cocina de autor, mezcla de estilos.' },
    { value: 'saludable', label: 'Saludable: Vegetariana, vegana, ensaladas, bowls.' },
  ],

  // Cafetería / Fonda / Cocina Económica
  cafeteria: [
    { value: 'desayunos_brunch', label: 'Desayunos y Almuerzos (Brunch): Chilaquiles, huevos, hot cakes.' },
    { value: 'comida_corrida', label: 'Comida Corrida / Menú del Día: Guisados, sopas, platos caseros.' },
    { value: 'antojitos_mexicanos', label: 'Antojitos Mexicanos: Quesadillas, sopes, tlacoyos.' },
    { value: 'sandwiches_tortas', label: 'Sándwiches, Tortas y Baguettes' },
    { value: 'cafe_panaderia', label: 'Café, Panadería y Postres' },
  ],

  fonda: [
    { value: 'desayunos_brunch', label: 'Desayunos y Almuerzos (Brunch): Chilaquiles, huevos, hot cakes.' },
    { value: 'comida_corrida', label: 'Comida Corrida / Menú del Día: Guisados, sopas, platos caseros.' },
    { value: 'antojitos_mexicanos', label: 'Antojitos Mexicanos: Quesadillas, sopes, tlacoyos.' },
    { value: 'sandwiches_tortas', label: 'Sándwiches, Tortas y Baguettes' },
    { value: 'cafe_panaderia', label: 'Café, Panadería y Postres' },
  ],

  // Bar / Club Nocturno
  bar: [
    { value: 'cocteleria', label: 'Coctelería: Clásica, de autor, ginebra, mezcales.' },
    { value: 'cerveceria', label: 'Cervecería: Artesanal, nacional, importada.' },
    { value: 'vinos_licores', label: 'Vinos y Licores' },
    { value: 'botanas_alitas', label: 'Botanas y Alitas (Snacks)' },
  ],

  club_nocturno: [
    { value: 'cocteleria', label: 'Coctelería: Clásica, de autor, ginebra, mezcales.' },
    { value: 'cerveceria', label: 'Cervecería: Artesanal, nacional, importada.' },
    { value: 'vinos_licores', label: 'Vinos y Licores' },
    { value: 'botanas_alitas', label: 'Botanas y Alitas (Snacks)' },
  ],

  // Food Truck / Comida Rápida
  food_truck: [
    { value: 'boneless_alitas', label: 'Boneless y alitas' },
    { value: 'hamburguesas', label: 'Hamburguesas' },
    { value: 'hot_dogs', label: 'Hot Dogs y Salchichas' },
    { value: 'tacos_burritos', label: 'Tacos y Burritos' },
    { value: 'pizzas', label: 'Pizzas' },
    { value: 'papas_frituras', label: 'Papas y Frituras' },
  ],

  comida_rapida: [
    { value: 'boneless_alitas', label: 'Boneless y alitas' },
    { value: 'hamburguesas', label: 'Hamburguesas' },
    { value: 'hot_dogs', label: 'Hot Dogs y Salchichas' },
    { value: 'tacos_burritos', label: 'Tacos y Burritos' },
    { value: 'pizzas', label: 'Pizzas' },
    { value: 'papas_frituras', label: 'Papas y Frituras' },
  ],

  // Taquería
  taqueria: [
    { value: 'tacos_pastor', label: 'Tacos de pastor, bistec, etc.' },
    { value: 'tacos_guisado', label: 'Tacos de Guisado' },
    { value: 'tacos_dorados', label: 'Tacos dorados' },
  ],

  // Otro comercio de alimentos/bebidas
  otro: [
    { value: 'carniceria', label: 'Carnicería' },
    { value: 'marisqueria', label: 'Marisquería' },
    { value: 'cremeria_quesos', label: 'Cremería/Quesos' },
    { value: 'postres_reposteria', label: 'Postres y Repostería' },
    { value: 'bebidas_jugos', label: 'Bebidas y Jugos' },
    { value: 'helados_nieves', label: 'Helados y Nieves' },
    { value: 'gourmet_delicatessen', label: 'Productos Gourmet / Delicatessen' },
  ],

  // No gastronómico
  no_gastronomico: [
    { value: 'farmacia', label: 'Farmacia' },
    { value: 'ferreteria', label: 'Ferretería' },
    { value: 'abarrotes', label: 'Abarrotes' },
    { value: 'supermercado', label: 'Supermercado' },
    { value: 'ropa_accesorios', label: 'Ropa y Accesorios' },
    { value: 'salud_belleza', label: 'Salud y Belleza' },
    { value: 'hogar', label: 'Artículos para el Hogar' },
  ],
};

// Tipos para TypeScript
export type BusinessType =
  | 'restaurante'
  | 'dark_kitchen'
  | 'cafeteria'
  | 'bar'
  | 'fonda'
  | 'food_truck'
  | 'comida_rapida'
  | 'club_nocturno'
  | 'taqueria'
  | 'otro'
  | 'no_gastronomico';

export type BusinessSubType = string; // Los subtipos son dinámicos según el tipo

// Helper function para obtener subtipos por tipo de negocio
export const getSubTypesByBusinessType = (businessType: BusinessType) => {
  return businessSubTypes[businessType] || [];
};
